module.exports = __webpack_public_path__ + "62b3656a0e7f47e811c48b5b63d7b46f.jpg";